/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { RunStateManager } from "./manager.js";
export const createRunStateManager = (resumeFrom = {}, inputs) => {
    return new RunStateManager(resumeFrom, inputs);
};
//# sourceMappingURL=index.js.map